module.exports = __webpack_public_path__ + "img/рз_buttocks.09e1eb44.png";